var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:`button-close button-close--${_vm.mode}`,attrs:{"fab":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"d-flex",domProps:{"innerHTML":_vm._s(require(`@/assets/img/icons/error.svg`))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }